// extracted by mini-css-extract-plugin
export default {"container":"LoginMenu_container__FkO4v","header":"LoginMenu_header__+anXt","menu_row":"LoginMenu_menu_row__qYnt5","icon":"LoginMenu_icon__s1iJU"};